var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weather-icon"},[_c('img',{attrs:{"src":_vm.weatherIconUrl}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.currentWeather.temperature)+" ℃")])])
}
var staticRenderFns = []

export { render, staticRenderFns }